import * as React from "react";
const SvgBe = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 2888.889 2000", style: {
  enableBackground: "new 0 0 2888.889 2000"
}, xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("g", { id: "_x31_1" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("polygon", { style: {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#000101"
}, points: "0,2000 963.09,2000 963.09,0 0,0 0,2000  " }), /* @__PURE__ */ React.createElement("polygon", { style: {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#F7DE29"
}, points: "963.09,2000 1925.988,2000 1925.988,0 963.09,0  963.09,2000  " }), /* @__PURE__ */ React.createElement("polygon", { style: {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#DA1F27"
}, points: "1925.988,2000 2888.889,2000 2888.889,0 1925.988,0  1925.988,2000  " }))), /* @__PURE__ */ React.createElement("g", { id: "Layer_1" }));
export default SvgBe;
